import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Router } from '@angular/router';
import { BaseSiteService } from "@spartacus/core";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { LoactionStripService } from "src/app/shared/modules/location-strip/loaction-strip.service";
import { SharedService } from "src/app/shared/services/shared.service";
import { ResourcesService } from "../resources.service";


@Component({
    selector: 'app-request-confirmation',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './request-confirmation.component.html',
    styleUrls: ['./request-confirmation.component.scss'],
    standalone: false
})
export class RequestConfirmationComponent implements OnInit {

  requestItemSubscription: Subscription;
  accountInformationSub: Subscription;
  requestedItemList: any;
  accountInformation: any;

  isLocationSelected = false;
  selectedLoc: string = '';
  selectedAccNo: string = '';
  selectedLocSub: Subscription;
  baseSiteId: string;

  constructor(private readonly service: ResourcesService,
    private readonly baseSiteService: BaseSiteService,
    private readonly cd: ChangeDetectorRef,
    private router: Router,
    private readonly sharedService: SharedService,
    private locService: LoactionStripService) { }

  ngOnInit(): void {

    this.selectedLocSub = this.locService.emitSelectedLocs.subscribe(locs => {
      if (locs) {
        this.isLocationSelected = !!locs?.length;
        if (locs.length === 1) {
          this.selectedAccNo = locs[0]?.accountNumber;




          this.selectedLoc = locs[0]?.companyName + ' ' + '(' + this.selectedAccNo + ')';

          this.cd.detectChanges();
        }
        else {


          let selectedLocation = this.sharedService.getSessionStorage('defaultLocation');




          this.selectedLoc = selectedLocation[0]?.companyName + ' ' + '(' + selectedLocation[0]?.accountNumber + ')';

          if (this.selectedLoc !== undefined || this.selectedLoc! == null || this.selectedLoc === '') {
            this.isLocationSelected = true;
            this.selectedAccNo = this.getAccNoFromDefaultLoc(this.selectedLoc);
          }
        }
      }
      else {


        let selectedLocation = this.sharedService.getSessionStorage('defaultLocation');




        this.selectedLoc = selectedLocation[0]?.companyName + ' ' + '(' + selectedLocation[0]?.accountNumber + ')';

        if (this.selectedLoc !== undefined || this.selectedLoc! == null || this.selectedLoc === '') {
          this.isLocationSelected = true;
          this.selectedAccNo = this.getAccNoFromDefaultLoc(this.selectedLoc);
        }
      }
    });

    if (this.service.requestItemValues.getValue()) {
      this.requestItemSubscription = this.service.requestItemValues.subscribe((data) => {
        if (data) {
          this.requestedItemList = data;
        }
      });
    } else {
      if (localStorage.getItem('requestedItemList'))
        this.requestedItemList = JSON.parse(localStorage.getItem('requestedItemList'));
    }

    this.accountInformationSub = this.service.accountInformation.subscribe((res) => {
      if (res) {
        this.accountInformation = res;
      }
    });

    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.cd.detectChanges();
  }

  getAccNoFromDefaultLoc(defaultLoc) {
    if (defaultLoc) {
      return defaultLoc?.accountNumber;
    }
    else {
      return '';
    }
  }

  navigateBack() {

    this.router.navigateByUrl('patientEducation');
  }
  ngOnDestroy(): void {
    this.selectedLocSub?.unsubscribe();
    this.requestItemSubscription?.unsubscribe();
    this.accountInformationSub.unsubscribe();
  }
}